import { AxiosError } from "axios"
import {
  ErrorResponseWithMessage,
  ErrorResponseWithMessages,
  TCSAPIResponse
} from "@/types/types"

// format response will return a response object {data: {} or [], err: string}
export const formatResponse = <T>(
  tcsApiResponse: TCSAPIResponse | null,
  error: AxiosError | null,
): { data: T | undefined, err: string | undefined } => {
  const formattedRes: { data: T | undefined, err: string | undefined } = {
    data: undefined,
    err: undefined
  }
  if (tcsApiResponse?.success) {
    formattedRes.data = (tcsApiResponse.data ?? {}) as T
  } else if (tcsApiResponse?.message) {
    formattedRes.err = tcsApiResponse.message
  } else if (error?.response?.data) {
    const errorResponseWithMessage = error.response.data as ErrorResponseWithMessage
    const errorResponseWithMessages = error.response.data as ErrorResponseWithMessages

    if (errorResponseWithMessage.message) {
      formattedRes.err = errorResponseWithMessage.message;
    } else if (errorResponseWithMessages.messages && errorResponseWithMessages.messages.length > 0) {
      formattedRes.err = errorResponseWithMessages.messages.join(', ');
    } else {
      formattedRes.err = 'Unable to fetch from API';
    }
  } else {
    formattedRes.err = 'Unable to fetch from API'
  }

  return formattedRes
}
